'use client'

import { Icon } from '../icon/icon.tsx'
import type { IconColor } from '../icon/types/core.ts'
import type { IconName } from '../icon/types/names.ts'
import { type AlertType, useAlertContext } from './use-alert.ts'

const indicatorColorMap: Record<AlertType, IconColor> = {
  info: 'info',
  notice: 'notice',
  warning: 'caution',
}

const indicatorNameMap: Record<AlertType, IconName> = {
  info: 'ExclamationCircleIcon',
  notice: 'ExclamationCircleIcon',
  warning: 'ExclamationCircleIcon',
}

export const AlertIndicator = ({ name }: { name?: IconName }) => {
  const { type } = useAlertContext()

  return (
    <Icon
      name={name ?? indicatorNameMap[type]}
      size="xl"
      color={indicatorColorMap[type]}
      className="flex-initial"
    />
  )
}
